import { HelpOutlineOutlined } from '@mui/icons-material'
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material'
import { useNavigate } from 'react-router-dom'
import AccountUser from '../../../Assets/Images/account-user.png'
import { logout } from '../../../Helpers/Util'
import NotificationsSSE from '../../Notifications/NotificationSSE'
import MUIButton from '../MUI-Button'
import './header.scss'

const AccountDrawer = ({ userData, setDrawerOpen }: any) => {
  const { firstName = '', lastName = '' } = userData || {}
  const navigate = useNavigate()

  return (
    <Drawer anchor='right' open={true} onClose={() => setDrawerOpen(false)}>
      <div className='header-drawer-container'>
        <div className='drawer-header'>
          <img src={AccountUser} alt='' />
          <Typography className='drawer-header-text'>
            {firstName?.charAt(0).toUpperCase() + firstName?.slice(1)}{' '}
            {lastName?.charAt(0).toUpperCase() + lastName?.slice(1)}
          </Typography>
          <Typography className='drawer-header-email'>{userData?.userEmail}</Typography>
        </div>
        <div className='drawer-content'>
          <List>
            {[
              {
                lable: 'Helpdesk',
                icon: <HelpOutlineOutlined />,
                url: '/home/helpdesk',
              },
              {
                lable: 'All Notifications',
                icon: <NotificationsSSE isHeader={false} />,
                url: '/home/all-notifications',
              },
            ].map((item) => (
              <ListItem
                key={item.lable}
                sx={{ paddingInline: 0 }}
                data-testid={item.lable}
                onClick={() => {
                  setDrawerOpen(false)
                  navigate(item.url)
                }}
              >
                <ListItemButton>
                  <ListItemIcon sx={{ minWidth: '28px' }}>{item.icon}</ListItemIcon>
                  <ListItemText
                    primary={item.lable}
                    primaryTypographyProps={{
                      sx: { fontFamily: 'Inter, sans-serif' },
                    }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </div>
        <div className='drawer-footer'>
          <MUIButton
            type={'button'}
            label={'Logout'}
            variant='contained'
            color={'error'}
            width={'48%'}
            handleClickCB={logout}
          />
          <MUIButton
            type={'button'}
            label={'Cancel'}
            variant='outlined'
            color={'secondary'}
            width={'48%'}
            handleClickCB={() => setDrawerOpen(false)}
          />
        </div>
      </div>
    </Drawer>
  )
}
export default AccountDrawer
